import React, { useState, useMemo, useRef } from "react";

export default function SearchSelect(props) {
  const {
    listOfValues,
    setSelectedValue,
    placeholder = "please select country",
    defaultValue = "",
  } = props;
  const [value, setValue] = useState(defaultValue);
  props.searchSelectRef.focusSearch = focusSearch;
  const inputRef = useRef(null);
  const [dropdownSection, setDropdownSection] = useState("");
  function handleFocus() {
    setDropdownSection(true);
  }
  function handleBlur() {
    setSelectedValue({ label: value });
    setDropdownSection(false);
  }
  function focusSearch() {}
  const getLanguages = useMemo(() => {
    return listOfValues.filter((accnt) => {
      return accnt.label.toLowerCase().includes(value.toLowerCase());
    });
  }, [value, listOfValues]);

  function handleSetValue(val) {
    setValue(val.label);
    setSelectedValue(val);
    setDropdownSection(false);
  }

  function toggleDropdown() {
    setDropdownSection(!dropdownSection);
  }
  return (
    <div
      onClick={focusSearch}
      className="bg-red max-w-md mx-auto font-metropolis"
    >
      <div className="flex-auto flex flex-col items-center">
        <div className="flex flex-col items-center relative w-full">
          <div className="w-full  svelte-1l8159u">
            <div className="my-2 bg-opacity-0 bg-black p-1 flex border border-gray-200 rounded svelte-1l8159u">
              <div className="flex flex-auto flex-wrap"></div>
              <input
                onFocus={handleFocus}
                onChange={(e) => setValue(e.target.value)}
                // onBlur={handleBlur}
                ref={inputRef}
                autoComplete="new-input"
                type="text"
                placeholder={placeholder}
                value={value}
                className="utilInputPlaceholder p-1 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black "
              />
              {dropdownSection && (
                <div
                  onClick={handleBlur}
                  className="fixed inset-0 h-full w-full z-10"
                ></div>
              )}
              <div>
                <button
                  onClick={() => setValue("")}
                  className="cursor-pointer w-6 h-full flex items-center text-theme outline-none focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-x w-4 h-4"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="text-theme w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200 svelte-1l8159u">
                <button
                  onClick={toggleDropdown}
                  className={`cursor-pointer w-6 h-6 text-theme outline-none focus:outline-none ${
                    dropdownSection ? "rotate-180" : ""
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-up w-4 h-4"
                  >
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          {dropdownSection && (
            <div className="absolute shadow top-14 z-40 w-full left-0 rounded max-h-select overflow-y-auto svelte-5uyqqj">
              <div className="flex flex-col w-full">
                {getLanguages.slice(0, 5).map((lang, i) => (
                  <div
                    key={i}
                    className="cursor-pointer w-full border-gray-100 rounded-t border-b 
            hover:bg-teal-100"
                  >
                    <div
                      onClick={() => handleSetValue(lang)}
                      className="flex w-full items-center p-2 pl-2 border-transparent bg-white border-l-2 relative hover:bg-blue-500 hover:text-theme hover:blue-500"
                    >
                      <div className="w-full items-center flex">
                        <div className="mx-2 leading-6">
                          {lang.labelformated}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
